import { InputTextarea } from 'primereact/inputtextarea';
import "./Input Box/InputBox.scss";

const TextArea = ({
    fieldName = "default",
    placeholder = "",
    styles = {},
    value = "",
    customLabelName = "",
    handleChange = () => { },
    inputStyles = {},
    labelStyles = {},
    hasError = false,
    required = false,
}) => {

    const labelName = fieldName
        ? fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase() + ":"
        : "Field Name";

    return (
        <div style={styles}>
            <label
                htmlFor={fieldName}
                style={labelStyles}
            >
                {customLabelName ? customLabelName : labelName}
                {required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
            </label>
            <InputTextarea
                id={fieldName}
                name={fieldName}
                onChange={handleChange}
                value={value}
                style={inputStyles}
                placeholder={placeholder}
                className="textarea-placeholder"
                invalid={hasError}
            />
        </div>
    )
}

export default TextArea
